import { Link } from 'react-router-dom';
import { useScrollAnimation, useStaggerAnimation } from '@/hooks/useScrollAnimation';

const portfolios = [
  {
    title: '역삼동 래미안 아파트',
    info: '34평 · 2024.11 완공',
    tag: '강남구 아파트',
    img: 'https://public.readdy.ai/ai/img_res/0e4e4392542cb31d8c3ead246660171c.jpg',
  },
  {
    title: '대치동 은마 아파트',
    info: '42평 · 2024.09 완공',
    tag: '강남구 아파트',
    img: 'https://readdy.ai/api/search-image?query=high-end%20Korean%20apartment%20interior%20design%20completed%20project%2C%20spacious%20dining%20area%20with%20designer%20furniture%2C%20open%20kitchen%2C%20sophisticated%20color%20scheme%2C%20premium%20finishes&width=600&height=800&seq=port002&orientation=portrait',
  },
  {
    title: '청담동 카페 리모델링',
    info: '상업공간 · 2024.08 완공',
    tag: '강남구 상업',
    img: 'https://readdy.ai/api/search-image?query=stylish%20Korean%20cafe%20interior%20renovation%20completed%2C%20warm%20wood%20tones%2C%20industrial%20chic%20design%2C%20cozy%20seating%20areas%2C%20pendant%20lighting%2C%20modern%20coffee%20shop%20atmosphere&width=600&height=800&seq=port003&orientation=portrait',
  },
  {
    title: '삼성동 오피스텔',
    info: '18평 · 2024.07 완공',
    tag: '강남구 오피스텔',
    img: 'https://readdy.ai/api/search-image?query=compact%20modern%20Korean%20officetel%20interior%20renovation%20completed%2C%20smart%20storage%20solutions%2C%20minimalist%20bedroom%20and%20living%20area%2C%20clean%20white%20and%20wood%20tones%2C%20functional%20design&width=600&height=800&seq=port004&orientation=portrait',
  },
];

export default function PortfolioPreview() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, getItemStyle } = useStaggerAnimation(portfolios.length);

  return (
    <section className="bg-[#f0eee9] py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className="flex flex-col md:flex-row md:items-end justify-between mb-12 md:mb-16 gap-4 md:gap-6 text-center md:text-left"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? 'translateY(0)' : 'translateY(36px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
          }}
        >
          <div>
            <span className="text-[#c9a84c] text-xs tracking-[0.3em] uppercase font-medium">Portfolio</span>
            <h2 className="text-3xl md:text-5xl font-light text-[#2a2218] mt-3 md:mt-4 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              시공 사례
            </h2>
          </div>
          <Link
            to="/portfolio"
            className="inline-flex items-center justify-center md:justify-start gap-2 text-[#3a3228] text-sm font-medium border-b border-[#3a3228]/40 pb-1 whitespace-nowrap cursor-pointer hover:text-[#c9a84c] hover:border-[#c9a84c] transition-colors mx-auto md:mx-0"
          >
            전체 포트폴리오 보기
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div
          ref={gridRef as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {portfolios.map((p, i) => (
            <div key={p.title} className="group cursor-pointer" style={getItemStyle(i)}>
              <div className="relative w-full h-[420px] rounded-2xl overflow-hidden">
                <img
                  src={p.img}
                  alt={p.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                <div className="absolute top-4 right-4">
                  <span className="bg-[#c9a84c] text-[#0d0d0d] text-xs font-bold px-3 py-1.5 rounded-full">
                    {p.tag}
                  </span>
                </div>
                <div className="absolute bottom-5 left-5 right-5">
                  <h3 className="text-white font-semibold text-base mb-1">{p.title}</h3>
                  <p className="text-white/60 text-xs">{p.info}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
